import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouterOutlet, AsyncPipe],
  selector: 'aux-line-chart',
  styles: [],
  templateUrl: './scenario.component.html',
})
export class ScenarioComponent {
  rightSideContainer = new BehaviorSubject<null | TemplateRef<unknown>>(null);
}
